import { get, set, del } from 'idb-keyval'
import type {
  Persister,
  PersistedClient,
} from '@tanstack/react-query-persist-client'

const IDB_KEY = 'wondermaps-query-cache'

export const queryPersister: Persister = {
  persistClient: async (client: PersistedClient) => {
    await set(IDB_KEY, client)
  },
  restoreClient: async () => {
    return await get<PersistedClient>(IDB_KEY)
  },
  removeClient: async () => {
    await del(IDB_KEY)
  },
}

export function shouldDehydrateQuery(query: {
  queryKey: readonly unknown[]
  state: { status: string }
}): boolean {
  const queryKey = query.queryKey
  // Only persist successful visitor-map queries (failed queries may contain non-serializable errors)
  return (
    Array.isArray(queryKey) &&
    queryKey[0] === 'visitor-map' &&
    query.state.status === 'success'
  )
}
